const WIN_CELEBRATIONS = 29
const WIN_DELAY_MS = [200, 800]

const explodeConfig = {
  id: 'tsparticles',
  options: {
    fullScreen: {
      zIndex: 1,
    },
    emitters: {
      position: {
        x: 50,
        y: 100,
      },
      rate: {
        quantity: 5,
        delay: 0.15,
      },
    },
    particles: {
      color: {
        value: [
          '#1E00FF',
          '#FF0061',
          '#E1FF00',
          '#00FF9E',
        ],
      },
      move: {
        decay: 0.05,
        direction: 'top',
        enable: true,
        gravity: {
          enable: true,
        },
        outModes: {
          top: 'none',
          default: 'destroy',
        },
        speed: {
          min: 50,
          max: 100,
        },
      },
      number: {
        value: 0,
      },
      opacity: {
        value: 1,
      },
      rotate: {
        value: {
          min: 0,
          max: 360,
        },
        direction: 'random',
        animation: {
          enable: true,
          speed: 30,
        },
      },
      tilt: {
        direction: 'random',
        enable: true,
        value: {
          min: 0,
          max: 360,
        },
        animation: {
          enable: true,
          speed: 30,
        },
      },
      size: {
        value: 3,
        animation: {
          enable: true,
          startValue: 'min',
          count: 1,
          speed: 16,
          sync: true,
        },
      },
      roll: {
        darken: {
          enable: true,
          value: 25,
        },
        enlighten: {
          enable: true,
          value: 25,
        },
        enable: true,
        speed: {
          min: 5,
          max: 15,
        },
      },
      wobble: {
        distance: 30,
        enable: true,
        speed: {
          min: -7,
          max: 7,
        },
      },
      shape: {
        type: [
          'circle',
          'square',
        ],
        options: {},
      },
    },
    responsive: [
      {
        maxWidth: 1024,
        options: {
          particles: {
            move: {
              speed: {
                min: 33,
                max: 66,
              },
            },
          },
        },
      },
    ],
  },
}

const realistic = (x, y, heart=false) => {
  if (!window.confetti) {
    console.warn('no confetti')
    return
  }
  const count = 200
  if (x === undefined || y === undefined) {
    x = Math.random()
    y = Math.random()
  }
  const defaults = {
    origin: { x, y },
  };

  if (heart) {
    defaults.shapes = ["heart"];
    defaults.colors = ["FFC0CB", "FF69B4", "FF1493", "C71585"]
    defaults.gravity = 0
  }

  function fire(particleRatio, opts) {
    window.confetti(
      Object.assign({}, defaults, opts, {
        particleCount: Math.floor(count * particleRatio),
        scalar: heart ? (opts.scalar || 1) * 2 : opts.scalar,
      })
    );
  }

  fire(0.25, {
    spread: 26,
    startVelocity: 55,
  });

  fire(0.2, {
    spread: 60,
  });

  fire(0.35, {
    spread: 100,
    decay: 0.91,
    scalar: 0.8,
  });

  fire(0.1, {
    spread: 120,
    startVelocity: 25,
    decay: 0.92,
    scalar: 1.2,
  });

  fire(0.1, {
    spread: 120,
    startVelocity: 45,
  });
}

const explode = () => {
  if (!window.confetti) {
    console.warn('no confetti')
    return
  }
  window.confetti(explodeConfig)
}

const celebrate = (n = WIN_CELEBRATIONS, heart=false) => {
  if (!window.confetti) {
    console.warn('no confetti')
    return  
  }
  for (let i = 0; i < n; i++) {
    const winDelay = WIN_DELAY_MS[0] + Math.random() * (WIN_DELAY_MS[1] - WIN_DELAY_MS[0])
    setTimeout(() => realistic(undefined, undefined, heart), i * winDelay)
  }
}

export { explode, realistic, celebrate }
